
    "use strict";

    var $controller = {

        dom: window.jQuery,

        init: function() {
            setTimeout(function() {
                $controller.match();
            }, 50);
        },

        match: function() {

            var $height = 0;

            var $boxes = this.dom('.vc_message_box');

            $boxes.each(function() {
                var $h = $controller.dom(this).height();
                if($height < $h) {
                    $height = $h;
                }
            });

            if($height > 0) {
                $boxes.css('height', ($height + 100)+'px');
            }

        }

    };

    $controller.init();


// WEBPACK FOOTER //
// ./build/vendor/tbo/js/widget/boxes.js